<template>
  <div>
    <v-app-bar app flat clipped-right dark color="primary">
      <v-app-bar-nav-icon
        @click.native.stop="updateUILeftDrawerState(!UILeftDrawer)"
        v-if="!screenIsWideEnough"
      ></v-app-bar-nav-icon>
      <v-tabs v-model="tabs" background-color="transparent" center-active grow slider-color="accent">
        <v-tab
          v-for="queue in DiallerQueues"
          :key="queue.id"
          :to="{ name: 'Dialler', params: { diallerQueueId: queue.id } }"
        >
          <v-badge color="error" :content="queue.count" :value="queue.count > 0">
            {{ queue.name }}
          </v-badge>
        </v-tab>
      </v-tabs>
    </v-app-bar>
    <v-content class="full-height unscrollable">
      <v-container fluid py-0 class="grey lighten-2">
        <v-row class="calc-height" fill-height align="center" v-if="DiallerQueueCallList.length === 0">
          <v-col align="center">
            <p class="display-1 mt-5 grey--text text--darken-2">
              This queue is currently empty.
            </p>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="2" sm="3" class="calc-height unscrollable pt-1 px-0" ref="scrollContainer">
            <v-list dense two-line class="calc-height scrollable transparent">
              <v-list-item-group v-model="referral" mandatory active-class="selected">
                <template v-for="(phoneCall, index) in callList">
                  <DiallerCallCard
                    :dark="phoneCall.id === phoneCallId"
                    :selected-dialler-queue="diallerQueueId"
                    :phone-call="phoneCall"
                    :phone-call-index="index"
                    :key="`referral-${phoneCall.id}`"
                  />
                </template>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col class="calc-height">
            <DiallerRegistration
              v-if="
                SelectedDiallerQueue !== null &&
                  SelectedPhoneCall !== null &&
                  SelectedPhoneCall !== undefined &&
                  SelectedPhoneCall.subject.type === 'Referral'
              "
              :selected-phone-call="SelectedPhoneCall"
              :selected-referral="SelectedReferral"
              :key="SelectedPhoneCall.id"
              :dialler="true"
            />
            <Customer
              v-if="
                SelectedDiallerQueue !== null &&
                  SelectedPhoneCall !== null &&
                  SelectedPhoneCall !== undefined &&
                  SelectedPhoneCall.subject.type === 'Customer'
              "
              :id="SelectedReferral.customer.id"
              :dialler="true"
              :key="SelectedPhoneCall.id"
            ></Customer>
          </v-col>
        </v-row>
      </v-container>
      <v-fab-transition>
        <v-btn
          :key="activeFab.icon"
          :color="activeFab.colour"
          dark
          fab
          bottom
          right
          fixed
          v-if="showDiallerIcon"
          @click="toggleActiveCall"
        >
          <v-icon>{{ activeFab.icon }}</v-icon>
        </v-btn>
      </v-fab-transition>
      <CloseCallDialog :show.sync="showDialog" :key="phoneCallId" />
    </v-content>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';

import Echo from '../../../plugins/echo';
import TwilioDevice from '../../../plugins/twilio';

import CloseCallDialog from './CloseCallDialog';
import Customer from '../Customers/Customer';
import DiallerCallCard from './DiallerCallCard';
import DiallerRegistration from './DiallerRegistration';

//TODO: Add Twilio client UI
//TODO: Auto-dial next item in the queue

export default {
  name: 'Dialler',
  components: { CloseCallDialog, DiallerRegistration, Customer, DiallerCallCard },
  props: {
    diallerQueueId: String,
    phoneCallId: String
  },
  data: () => ({
    tabs: null,
    referral: null,
    fab: false,
    showDialog: false
  }),
  computed: {
    ...mapGetters([
      'ActiveCall',
      'DiallerQueues',
      'GetDiallerQueue',
      'DiallerQueueCallList',
      'SelectedDiallerQueue',
      'SelectedPhoneCall',
      'SelectedReferral',
      'UILeftDrawer',
      'UserHasRole',
      'UserId'
    ]),
    callList() {
      return this.DiallerQueueCallList;
    },
    selectedQueue: {
      get() {
        return this.SelectedDiallerQueue;
      },
      set(queue) {
        this.selectDiallerQueue(queue);
      }
    },
    activeFab() {
      return {
        icon: this.ActiveCall !== null ? 'fad fa-phone-slash' : 'fad fa-phone',
        colour: this.ActiveCall !== null ? 'red darken-2' : 'green darken-2'
      };
    },
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    },
    showDiallerIcon() {
      return (TwilioDevice && this.SelectedPhoneCall && this.DiallerQueueCallList.length > 0) || this.ActiveCall;
    },
    referrerType() {
      return this.SelectedReferral.referrer.business_type === 'sub_partner'
        ? 'partner'
        : this.SelectedReferral.referrer.business_type;
    }
  },
  methods: {
    ...mapActions([
      'addCallToQueue',
      'addNotification',
      'clearActiveCall',
      'getPhoneCallOutcomes',
      'removeCallFromQueue',
      'selectDiallerQueue',
      'selectPhoneCall',
      'setActiveCall',
      'updateActiveCall',
      'updateUILeftDrawerState'
    ]),
    getPage: _.debounce(function() {
      this.getReferralsPage(false).catch(error => {
        console.log(error);
      });
    }, 250),
    scrollPage() {
      if (this.ReferralCurrentPage < this.ReferralLastPage) {
        this.getReferralsPage(true).catch(error => {
          console.log(error);
        });
      }
    },
    scrollToTop() {
      if ('scrollBehavior' in document.documentElement.style) {
        this.$refs.scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        this.$refs.scrollContainer.scrollTo(0, 0);
      }
    },
    changeQueue(queue) {
      if (!queue) {
        queue = this.DiallerQueues[0];
      }
      this.selectDiallerQueue(queue.id);
    },
    listenForNewCalls() {
      Echo.private(`Dialler.PhoneCall.${this.UserId}`)
        .listen('PhoneCall\\PhoneCallAssigned', event => {
          this.addCallToQueue(event.phoneCall);
        })
        .listen('PhoneCall\\PhoneCallUnassigned', event => {
          this.removeCallFromQueue(event.id);
        });
    },
    stopListeningForNewCalls() {
      Echo.leave(`Dialler.PhoneCall.${this.UserId}`);
    },
    toggleActiveCall() {
      if (this.ActiveCall) {
        this.showDialog = true;
      } else {
        this.setActiveCall(this.SelectedPhoneCall);
      }
    }
  },
  // watch: {
  //   diallerQueueId: function(id) {
  //     if (id !== undefined) {
  //       this.selectDiallerQueue(id);
  //     }
  //   },
  //   phoneCallId: function(id) {
  //     if (id !== undefined) {
  //       this.selectPhoneCall(id);
  //     }
  //   }
  // },
  mounted() {
    this.getPhoneCallOutcomes();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (to.params.diallerQueueId !== undefined) {
        vm.selectDiallerQueue({ diallerQueueId: to.params.diallerQueueId, phoneCallId: to.params.phoneCallId });
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    if (typeof to.params.diallerQueueId !== 'undefined') {
      this.selectDiallerQueue({ diallerQueueId: to.params.diallerQueueId, phoneCallId: to.params.phoneCallId });
    }
    next();
  }
};
</script>

<style lang="scss" scoped>
.icon-phone {
  --fa-primary-color: #569700;
  --fa-secondary-color: #88c83d;
  --fa-primary-opacity: 1;
  --fa-secondary-opacity: 1;
}

.icon-phone-slash {
  --fa-primary-color: #c50e29;
  --fa-secondary-color: #ff5252;
  --fa-primary-opacity: 1;
  --fa-secondary-opacity: 1;
}

.icon-sms {
  --fa-primary-color: #fff;
  --fa-secondary-color: #2196f3;
  --fa-primary-opacity: 1;
  --fa-secondary-opacity: 1;
}

.full-height {
  height: 100vh;
  max-height: 100vh;
  -webkit-overflow-scrolling: touch;
}

.calc-height {
  height: calc(100vh - 72px);
  max-height: calc(100vh - 72px);
  -webkit-overflow-scrolling: touch;
}

.unscrollable {
  overflow-y: hidden;
}

.scrollable {
  overflow-y: auto;
}

.selected {
  .v-list_item__title {
    font-weight: 600;
  }

  .v-list_item__subtitle {
    color: rgba(255, 255, 255, 0.87);
  }
}
</style>
